import React from 'react';
import Stack from '@/components/Stack';
import Chip from '@/components/Chip';
import { Heading, Body, Small } from '@/components/Typography';
import { ReviewHistoryEntry } from '@/services/assessmentsAPI';

interface ReviewHistoryProps {
  history: ReviewHistoryEntry[];
}

const ReviewHistory: React.FC<ReviewHistoryProps> = ({ history }) => {
  if (!history || history.length === 0) {
    return null;
  }

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const getStatusColor = (
    status: string,
  ): 'success' | 'error' | 'warning' | 'primary' => {
    switch (status) {
      case 'passed':
        return 'success';
      case 'failed':
        return 'error';
      case 'for_review':
        return 'warning';
      default:
        return 'primary';
    }
  };

  return (
    <Stack vertical gap={16}>
      <Heading>Review History ({history.length})</Heading>
      <Stack vertical gap={12}>
        {history.map((entry, index) => (
          <div
            key={index}
            style={{
              padding: '12px',
              backgroundColor: '#f5f5f5',
              borderRadius: '8px',
              borderLeft: '3px solid #ddd',
            }}
          >
            <Stack vertical gap={8}>
              <Stack justify="apart" align="center">
                <Chip
                  color={getStatusColor(entry.final_status)}
                  label={entry.final_status.replace(/_/g, ' ')}
                />
                {entry.final_score !== null && (
                  <Small weight="semibold">Score: {entry.final_score}</Small>
                )}
              </Stack>
              <Stack justify="apart">
                <Small color="light">Reviewed by</Small>
                <Small>
                  {entry.reviewed_by_name || `Admin #${entry.reviewed_by_id}`}
                </Small>
              </Stack>
              <Stack justify="apart">
                <Small color="light">Date</Small>
                <Small>{formatDate(entry.reviewed_at)}</Small>
              </Stack>
              {entry.notes && (
                <Stack vertical gap={4}>
                  <Small color="light">Notes</Small>
                  <Body>{entry.notes}</Body>
                </Stack>
              )}
            </Stack>
          </div>
        ))}
      </Stack>
    </Stack>
  );
};

export default ReviewHistory;
